import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MAT_DATE_LOCALE,MAT_DATE_FORMATS,DateAdapter } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ToastrManager } from 'ng6-toastr-notifications';
import { JwtService } from '../../../../../../shared/services/jwt.service';
import { JwtUserModel } from '../../../../../../shared/models/jwt-user.model';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CargoLaboralService } from '../../../_core/services/cargolaboral.service';
import { BlacklistService } from '../../../_core/services/blacklist.service';

@Component({
  selector: 'm-add-persona-blacklist',
  templateUrl: './add-persona-blacklist.component.html',
  styleUrls: ['./add-persona-blacklist.component.scss']
})
export class AddPersonaBlacklistComponent implements OnInit {

  viewLoading: boolean = false;
  usuario: string;
  isReadOnly: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<AddPersonaBlacklistComponent>,
    private _formBuilder_lote: FormBuilder,
    public cargo_s: CargoLaboralService,
    private jwtService: JwtService,
    public toastr: ToastrManager,
    public blacklist_s: BlacklistService,
		@Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  jwtUser: JwtUserModel;
  ngOnInit() {
    this.jwtUser = this.jwtService.getUser();
    this.create_form();
  }

  //#region COMBOS
  protected _onDestroy = new Subject<void>();

  //#endregion
  save_update(){
    const _controls = this.formMACRO.controls;
      if (this.formMACRO.invalid) {
        Object.keys(_controls).forEach(controlName =>
          _controls[controlName].markAsTouched()
        );
        this.toastr.warningToastr('Ingrese los campos obligatorios.', 'Advertencia!', {
          toastTimeout: 2000,
          showCloseButton: true,
          animate: 'fade',
          progressBar: true
        });
      } else {
        this.viewLoading = true;
        let model = {
          Dni: _controls.Dni.value,
          Nombres: _controls.Nombres.value,
          ApellidoPaterno: _controls.ApellidoPaterno.value,
          ApellidoMaterno: _controls.ApellidoMaterno.value,
          Motivo: _controls.Motivo.value
        };

        this.blacklist_s.SavePersonaBlacklist(model).subscribe(
          (data: any) => {
            if (data > 0) {
              this.toastr.successToastr('Se registro correctamente', 'Éxito!', {
                toastTimeout: 2000,
                showCloseButton: true,
                animate: 'fade',
                progressBar: true
              });
            } else {
              this.toastr.errorToastr('Ocurrio un error', 'Error!', {
                toastTimeout: 2000,
                showCloseButton: true,
                animate: 'fade',
                progressBar: true
              });
            }
            this.viewLoading = false;
            this.dialogRef.close(true);
          }, ( errorServicio ) => {
            this.toastr.errorToastr(errorServicio.message, 'Error!', {
              toastTimeout: 2000,
              showCloseButton: true,
              animate: 'fade',
              progressBar: true
            });
            this.viewLoading = false;
            console.log(errorServicio);
          }
        );
      }
      return;
  }

  formMACRO: FormGroup;
  create_form(){
    this.formMACRO = this._formBuilder_lote.group({
      Dni: [null, [Validators.required, Validators.minLength(8)]],
      Nombres: [null, Validators.required],
      ApellidoPaterno: [null, Validators.required],
      ApellidoMaterno: [null, Validators.required],
      Motivo: [null, Validators.required]
    });
  }

  buscarPersona() {
    this.blacklist_s.SearchPersonalActivoDni(this.formMACRO.controls['Dni'].value).subscribe(
      (data: any) => {
        if (data.length === 0) {
          this.toastr.infoToastr('Ingrese los nombres y apellidos.', 'información!', {
            toastTimeout: 2000,
            showCloseButton: true,
            animate: 'fade',
            progressBar: true
          });
          this.formMACRO.controls['Nombres'].reset();
          this.formMACRO.controls['ApellidoPaterno'].reset();
          this.formMACRO.controls['ApellidoMaterno'].reset();
          this.isReadOnly = false;
        } else {
          this.formMACRO.controls['Nombres'].setValue(data[0].Nombres);
          this.formMACRO.controls['ApellidoPaterno'].setValue(data[0].ApellidoPaterno);
          this.formMACRO.controls['ApellidoMaterno'].setValue(data[0].ApellidoMaterno);
        }
      }, ( errorServicio ) => {
          console.log(errorServicio);
      }
    );
  }


  onNoClick(): void {
		this.dialogRef.close();
  }

  onYesClick() {
    this.viewLoading = true;
    this.dialogRef.close(true);
  }

}
